import { z } from 'zod';

import { t } from '../i18n/validation.js';

const VERSION_REGEX = /^\d+\.\d+\.\d+$/;
const MAX_FILE_SIZE = 100 * 1024 * 1024;
const ALLOWED_EXTENSIONS = ['bin', 'hex', 'fw'];

export const firmwareFormSchema = z.object({
  version: z
    .string()
    .trim()
    .min(1, t('validation.firmware.versionRequired'))
    .max(32, t('validation.firmware.versionMaxLength'))
    .regex(VERSION_REGEX, t('validation.firmware.versionFormat')),
  deviceModels: z.array(z.string()).default([]),
  file: z
    .instanceof(File, { message: t('validation.firmware.fileRequired') })
    .refine(
      (file) => {
        const fileExtension = file.name.toLowerCase().split('.').pop();
        return ALLOWED_EXTENSIONS.includes(fileExtension || '');
      },
      { message: t('validation.firmware.fileExtension') },
    )
    .refine((file) => file.size <= MAX_FILE_SIZE, {
      message: t('validation.firmware.fileSize'),
    }),
});

export type FirmwareFormValues = z.infer<typeof firmwareFormSchema>;
